import { EventBus } from '@/plugins/event-bus'

const moduleState = {
  active: null,
  stockCarDetailPage: null,
  establishmentSelectionPage: null,
  dashboardPage: null,
  quoteOrderPage: null,
  purchaseOrderPage: null,
  purchaseOrderDetailsPage: null,
  instructionsPageViewmodel: null,
  precalculativeResultPage: null,
}

const getters = {
  get: (state) => state[state.active],
}

const mutations = {
  /* eslint-disable no-param-reassign */
  active: (state, payload) => {
    state.active = payload
  },
  stockCarDetailPage: (state, payload) => {
    state.stockCarDetailPage = payload
    EventBus.$emit('viewmodels/get')
  },
  dashboardPage: (state, payload) => {
    state.dashboardPage = payload
    EventBus.$emit('viewmodels/get')
  },
  establishmentSelectionPage: (state, payload) => {
    state.establishmentSelectionPage = payload
    EventBus.$emit('viewmodels/get')
  },
  quoteOrderPage: (state, payload) => {
    state.quoteOrderPage = payload
    EventBus.$emit('viewmodels/get')
  },
  purchaseOrderPage: (state, payload) => {
    state.purchaseOrderPage = payload
    EventBus.$emit('viewmodels/get')
  },
  purchaseOrderDetailsPage: (state, payload) => {
    state.purchaseOrderDetailsPage = payload
    EventBus.$emit('viewmodels/get')
  },
  precalculativeResultPage: (state, payload) => {
    state.precalculativeResultPage = payload
    EventBus.$emit('viewmodels/get')
  },
}

const actions = {
  active: ({ commit }, payload) => {
    commit('active', payload)
  },
  stockCarDetailPage: ({ commit }, payload) => {
    commit('stockCarDetailPage', payload)
  },
  dashboardPage: ({ commit }, payload) => {
    commit('dashboardPage', payload)
  },
  establishmentSelectionPage: ({ commit }, payload) => {
    commit('establishmentSelectionPage', payload)
  },
  quoteOrderPage: ({ commit }, payload) => {
    commit('quoteOrderPage', payload)
  },
  purchaseOrderPage: ({ commit }, payload) => {
    commit('purchaseOrderPage', payload)
  },
  purchaseOrderDetailsPage: ({ commit }, payload) => {
    commit('purchaseOrderDetailsPage', payload)
  },
  precalculativeResultPage: ({ commit }, payload) => {
    commit('precalculativeResultPage', payload)
  },
}

export default {
  state: moduleState,
  getters,
  mutations,
  actions,
  namespaced: true,
}
//
